export default (toolName : string, toolId : string) => {
  window.TRACKING_TOOLS.set(toolName, {
    required_cookie_settings: toolName,
    initTracking () {
      const script = document.createElement('script')
      script.src = `https://assets.adobedtm.com/175f7caa2b90/002e86d9628b/launch-${toolId}.min.js`
      script.async = true
      document.head.appendChild(script)
    },
  })
}
